import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-cmr',
  templateUrl: './terms-cmr.component.html',
  styleUrls: ['./terms-cmr.component.scss']
})
export class TermsCmrComponent {

  constructor() { }
}
